export default {
  BLACK_001: '#333333',
  BLACK_002: '#000000',

  GRAY_001: '#AEAEAE',
  GRAY_002: '#f6f8fa',
  GRAY_003: '#E9E9E7',

  WHITE_001: '#FFFFFF',
  WHITE_002: '#FAFAFF',

  ORANGE_001: '#F0582B',

  NAVY_BLUE_001: '#5D69F0',

  PURPLE_001: '#7B61FF',
};
